//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button, Input } from '../common';
import SearchDropdown from '../common/SearchDropdown';
import { useAppSelector } from '../../hooks/useAppSelector';
import { Listbox, ListboxButton, ListboxOptions, Switch, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '../icons';
import Datepicker from "tailwind-datepicker-react";
import { Textarea } from '../common/Textarea/Textarea';
import { log } from 'util';

export interface WorkingTypeOption {
  id: number;
  name: string;
  label: string;
  icon: string;
}

const wokringTypeOptions: WorkingTypeOption[] = [
  { id: 1, name: 'On-site', label: '#16a34a33', icon: '#15803d', nlabel: 'On_site' }, // Green
  { id: 2, name: 'Hybrid', label: '#1d4ed81a', icon: '#1d4ed8', nlabel: 'Hybrid' }, // blue
  { id: 3, name: 'Remote', label: '#ca8a0433', icon: '#854d0e', nlabel: 'Remote' }, // Amber/Yellow
];


interface StyledDropdownProps {
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const StyledDropdown = ({ options, value, onChange, placeholder }: StyledDropdownProps) => {
  const selectedOption = options.find(opt => opt.value === value);

  return (
    <Listbox value={value} onChange={onChange}>
      <div className="relative">
        <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-white py-2 pl-3 pr-10 text-left border border-gray-200 focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2">
          <span className={`block truncate text-[14px] ${!selectedOption ? 'text-gray-400' : 'text-gray-900'}`}>
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </span>
        </Listbox.Button>
        <Transition
          as={React.Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none">
            {options.map((option) => (
              <Listbox.Option
                key={option.value}
                value={option.value}
                className={({ active, selected }) =>
                  `relative cursor-pointer select-none py-2 px-4 ${active ? 'bg-gray-100' : 'text-gray-900'
                  }`
                }
              >
                {({ selected }) => (
                  <>
                    <span className={`block truncate text-[14px] ${selected ? 'font-medium' : 'font-normal'}`}>
                      {option.label}
                    </span>

                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};

interface DateSelectorProps {
  selectedStartMonth: string;
  selectedStartYear: string;
  selectedEndMonth: string;
  selectedEndYear: string;
  onMonthChange: (value: string) => void;
  onYearChange: (value: string) => void;
  label: string;
}

const DateSelector = ({
  selectedStartMonth,
  selectedStartYear,
  selectedEndMonth,
  selectedEndYear,
  onMonthChange,
  onYearChange,
  label
}: DateSelectorProps) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 1950 + 1 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString()
  }));

  const months = Array.from({ length: 12 }, (_, i) => ({
    value: (i + 1).toString().padStart(2, '0'),
    label: new Date(2000, i).toLocaleString('default', { month: 'long' })
  }));

  return (
    <div className=" space-y-1 md:space-y-2 lg:space-y-2">
      <label className="wg-label capitalize shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium">{label}</label>
      <div className="grid grid-cols-2 gap-2">
        <StyledDropdown
          options={months}
          value={label.includes("Joining") ? selectedStartMonth : selectedEndMonth}
          onChange={(value) => onMonthChange(value)}
          placeholder="Month"
        />
        <StyledDropdown
          options={years}
          value={label.includes("Joining") ? selectedStartYear : selectedEndYear}
          onChange={(value) => onYearChange(value)}
          placeholder="Year"
        />
      </div>
    </div>
  );
};


// Helper function to convert text with bullet points
const formatDescriptionWithBullets = (text) => {
  if (!text) return [];

  // Split by new lines or bullet point markers
  const lines = text.split(/\n|•/).map(line => line.trim()).filter(line => line);

  // Convert each line to a bullet point if it doesn't already start with one
  return lines.map(line => line.startsWith('•') ? line : `• ${line}`);
};

// Helper function to parse description text and detect if it contains bullet points
const parseDescription = (text) => {
  if (!text) return { hasListFormat: false, text };

  // Check if text contains bullet points or numbered lists
  const hasListFormat = /(\n|\r)[-•*]|^\s*[-•*]|\d+\.\s/.test(text);

  return { hasListFormat, text };
};



const WorkExperienceForm = ({ value, onChange, initialData, required, error }) => {
  const [experiences, setExperiences] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const locations = useAppSelector((state) => state?.jobs?.locationDetails);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [selectedWorkingType, setSelectedWorkingType] = useState<WorkingTypeOption | null>(wokringTypeOptions[0]);
  const [showEndDatePickers, setShowEndDatePickers] = useState({});
  const [showStartDatePickers, setShowStartDatePickers] = useState({});
  const [showEndDatePickers1, setShowEndDatePickers1] = useState({});
  const [showStartDatePickers1, setShowStartDatePickers1] = useState({});



  // Effect to handle initialData
  useEffect(() => {
    if (initialData && initialData.length > 0) {
      const formattedExperiences = initialData.map(exp => ({
        id: Date.now() + Math.random(),
        companyName: exp.company || '',
        jobTitle: exp.designation || '',
        currentlyWorking: exp.isCurrentJob,
        startDateMonth: exp.startDateMonth || '',
        startDateYear: exp.startDateYear || '',
        endDateMonth: exp.endDateMonth || '',
        endDateYear: exp.endDateYear || '',
        // endMonth: exp.isCurrentJob === "true" ? '' : exp.end_date_month || '',
        // endYear: exp.isCurrentJob === "true" ? '' : exp.end_date_year || '',
        location: exp.location || '',
        selectedCountry: findLocationFromString(exp.location),
        workplaceType: determineWorkplaceType(exp.workplace_type),
        description: exp.description || '' // Added description field
      }));
      setExperiences(formattedExperiences);
      setShowForm(true);
      const formattedExperience = formatExperiencesForParent(formattedExperiences);
      onChange({ target: { name: 'work_experience', value: formattedExperience } });
    }
  }, [initialData]);


  const handleDateChange = (id: number, type: 'start' | 'end', field: 'Month' | 'Year', value: string) => {
    const updatedExperiences = experiences.map(exp => {
      if (exp.id === id) {
        return {
          ...exp,
          [`${type}Date${field}`]: value // Changed to match your state structure
        };
      }
      return exp;
    });
    setExperiences(updatedExperiences);

    // Format the experience for parent
    const formattedExperience = formatExperiencesForParent(updatedExperiences);
    onChange({ target: { name: 'work_experience', value: formattedExperience } });
  };
  // Helper function to format date strings
  const formatDateString = (dateStr: string) => {
    if (!dateStr || dateStr === 'Present') return '';
    try {
      // Convert date string to Date object
      const [month, year] = dateStr.split('/');
      const date = new Date(parseInt(year), parseInt(month) - 1);
      return date.toISOString().split('T')[0];
    } catch (error) {
      return dateStr;
    }
  };

  // Helper function to find location in locations array
  const findLocationFromString = (locationStr: string) => {
    if (!locationStr || !locations) return null;
    return locations.find(loc =>
      loc.name.toLowerCase().includes(locationStr.toLowerCase()) ||
      locationStr.toLowerCase().includes(loc.name.toLowerCase())
    );
  };

  // Helper function to determine workplace type
  const determineWorkplaceType = (type: string) => {
    if (!type) return wokringTypeOptions[0];
    const foundType = wokringTypeOptions.find(option =>
      option.name.toLowerCase() === type.toLowerCase()
    );
    return foundType || wokringTypeOptions[0];
  };




  const handleAddExperience = () => {
    if (experiences.length >= 10) return;

    const newExperience = {
      id: Date.now(),
      companyName: '',
      jobTitle: '',
      currentlyWorking: false,
      startDateMonth: '',
      startDateYear: '',
      endDateMonth: '',
      endDateYear: '',
      location: '',
      selectedCountry: null,
      workplaceType: wokringTypeOptions[0],
      description: '' // Added description field
    };

    if (!showForm) {
      setShowForm(true);
      setExperiences([newExperience]);
    } else {
      setExperiences([...experiences, newExperience]);
    }
  };

  const handleDeleteExperience = (id) => {
    const updatedExperiences = experiences.filter(exp => exp.id !== id);
    if (updatedExperiences.length === 0) {
      setShowForm(false);
    }
    setExperiences(updatedExperiences);
    // Update parent form
    const formattedExperience = formatExperiencesForParent(updatedExperiences);
    onChange({ target: { name: 'work_experience', value: formattedExperience } });
  };

  // Update the handleExperienceChange function
  const handleExperienceChange = (id, field, value) => {
    const updatedExperiences = experiences.map(exp => {
      if (exp.id === id) {
        return { ...exp, [field]: value };
      }
      return exp;
    });
    setExperiences(updatedExperiences);

    // Create an event-like object to match the parent's expectations
    const formattedExperience = formatExperiencesForParent(updatedExperiences);
    onChange({
      target: {
        name: 'work_experience_status',
        value: formattedExperience
      }
    });
  };

  const formatExperiencesForParent = (experiences) => {
    return experiences.map(exp => ({
      company: exp.companyName,
      designation: exp.jobTitle,
      isCurrentJob: exp.currentlyWorking ? "true" : "false",
      startDateMonth: exp.startDateMonth,
      startDateYear: exp.startDateYear,
      endDateMonth: exp.currentlyWorking ? '' : exp.endDateMonth,
      endDateYear: exp.currentlyWorking ? '' : exp.endDateYear,
      location: exp.selectedCountry?.name || '',
      workplace_type: exp.workplaceType?.name || '',
      description: exp.description || '' // Added description field
    }));
  };

  const handleCountryChange = (id) => (country) => {
    const updatedExperiences = experiences.map(exp =>
      exp.id === id ? { ...exp, selectedCountry: country } : exp
    );
    setExperiences(updatedExperiences);
  };

  const handleWorkingTypeChange = async (newValue: WorkingTypeOption) => {
    setSelectedWorkingType(newValue);
  }

  const handleStartDatePickerClose = (id: number) => (state: boolean) => {
    setShowStartDatePickers(prev => ({
      ...prev,
      [id]: state
    }));
  };

  const handleEndDatePickerClose = (id: number) => (state: boolean) => {
    setShowEndDatePickers(prev => ({
      ...prev,
      [id]: state
    }));
  };


  // Function to render description content with or without bullet points
  const renderDescription = (description) => {
    const { hasListFormat, text } = parseDescription(description);

    if (hasListFormat) {
      const bulletPoints = formatDescriptionWithBullets(text);
      return (
        <ul className="list-disc pl-5 space-y-1 text-sm">
          {bulletPoints.map((point, idx) => (
            <li key={idx}>{point.replace(/^•\s*/, '')}</li>
          ))}
        </ul>
      );
    }

    return <p className="text-sm">{text}</p>;
  };

  // const 


  return (
    <div className="space-y-4">
      {showForm && experiences.map((experience, index) => (
        <div key={experience.id} className="p-0 ">
          <div className='bg-gray-100 p-4 rounded-md'>
            <div className='flex justify-end w-full'>
              <button
                type="button"
                onClick={() => handleDeleteExperience(experience.id)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={1}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-trash w-[1rem] h-[1rem] text-[#808080]"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 7l16 0" />
                  <path d="M10 11l0 6" />
                  <path d="M14 11l0 6" />
                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                </svg>
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Input
                  label="Company Name"
                  value={experience.companyName}
                  onChange={(e) => handleExperienceChange(experience.id, 'companyName', e.target.value)}
                  placeholder="Enter company name"
                />
                <div className="flex items-center gap-2 mt-1">
                  <input
                    type="checkbox"
                    id={`currently-working-${experience.id}`}
                    checked={experience.currentlyWorking}
                    onChange={(e) => handleExperienceChange(experience.id, 'currentlyWorking', e.target.checked)}
                    className="rounded border-gray-300  
                    checked:bg-[var(--component-primary-color)] checked:border-[var(--component-primary-color)]
                    focus:ring-2 focus:ring-[var(--hover-primary-color)] cursor-pointer"
                  />
                  <label
                    className="wg-label capitalize shrink-0 items-center gap-1 text-[12px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium"
                    htmlFor={`currently-working-${experience.id}`}>
                    Currently working here
                  </label>
                </div>
              </div>

              <Input
                label="Job Title"
                value={experience.jobTitle}
                onChange={(e) => handleExperienceChange(experience.id, 'jobTitle', e.target.value)}
                placeholder="Enter job title"
              />

              <div className="relative">
                <DateSelector
                  label="Date of Joining"
                  selectedStartMonth={experience.startDateMonth}
                  selectedStartYear={experience.startDateYear}
                  selectedEndMonth={experience.endDateMonth}
                  selectedEndYear={experience.endDateYear}
                  onMonthChange={(value) => handleDateChange(experience.id, 'start', 'Month', value)}
                  onYearChange={(value) => handleDateChange(experience.id, 'start', 'Year', value)}
                />
              </div>

              <div className="relative">
                {!experience.currentlyWorking && (
                  <DateSelector
                    label="Date of Relieving"
                    selectedStartMonth={experience.startDateMonth}
                    selectedStartYear={experience.startDateYear}
                    selectedEndMonth={experience.endDateMonth}
                    selectedEndYear={experience.endDateYear}
                    onMonthChange={(value) => handleDateChange(experience.id, 'end', 'Month', value)}
                    onYearChange={(value) => handleDateChange(experience.id, 'end', 'Year', value)}
                  />
                )}

              </div>


              {/* <Input
                label="Date of Joining"
                type="date"
                value={experience.startDate}
                onChange={(e) => handleExperienceChange(experience.id, 'startDate', e.target.value)}
              />

              <Input
                label="Date of Relieving"
                type="date"
                value={experience.endDate}
                onChange={(e) => handleExperienceChange(experience.id, 'endDate', e.target.value)}
              /> */}

              {/* <Input
                label="Location"
                value={experience.location}
                onChange={(e) => handleExperienceChange(experience.id, 'location', e.target.value)}
                placeholder="Enter location"
              /> */}
              <div className='flex flex-col gap-y-2 mt-1'>
                <label className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium">Location</label>
                <div className="relative">
                  <SearchDropdown
                    items={locations}
                    buttonText="Search by city, state, or country"
                    onChange={handleCountryChange(experience.id)}
                    selectedItem={experience.selectedCountry}
                    isLoading={loadingLocation}
                  />
                </div>

              </div>
              <div className='flex flex-col gap-y-2 mt-1'>
                <label

                  className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium"
                >
                  Work Type

                </label>
                <Listbox value={selectedWorkingType} onChange={handleWorkingTypeChange}>
                  {({ open }) => (
                    <div className="relative w-[100%]">
                      <Listbox.Button
                        className="inline-flex justify-between items-center w-full pl-3 pr-2 py-2 h-[42px] text-sm font-medium text-gray-700 bg-white border
                            border-gray-300 rounded-md shadow-sm button-hover-location !outline-offset-[-2px]
                            "
                      >
                        <div className="flex items-center gap-1 justify-between w-full">
                          <span className="col-start-1 row-start-1 truncate pr-6">{selectedWorkingType?.name}</span>
                          <ChevronDownIcon
                            aria-hidden="true"
                            className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                          />
                        </div>
                      </Listbox.Button>

                      <Transition show={open} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                        <Listbox.Options className="absolute z-10 w-[100%] left-[0px] mt-1 max-h-60 
        overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                          {wokringTypeOptions.map((option) => (
                            <Listbox.Option
                              key={option.id}
                              className={({ active }) =>
                                `relative cursor-default select-none py-1.5 pl-3 pr-9 text-[13px] ${active ? 'bg-light-gray-100 text-dark-black-100' : 'text-dark-black-100'
                                }`
                              }
                              value={option}
                            >
                              {({ selected }) => (
                                <div className="flex items-center gap-2">
                                  <span
                                    style={{ backgroundColor: option.icon }}
                                    className="flex h-[8px] w-[8px] shrink-0 items-center justify-center
                  rounded-full border-none text-[0.625rem] font-medium text-white capitalize"
                                  />
                                  <span
                                    className={`block truncate font-medium text-[13px] leading-4 whitespace-nowrap max-w-[140px] w-full 
                  overflow-hidden text-ellipsis text-start capitalize ${selected ? 'font-semibold' : 'font-normal'}`}
                                  >
                                    {option.name}
                                  </span>
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  )}
                </Listbox>
              </div>
            </div>
            <div className="mt-4">
              <label className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium">
                Description
              </label>
              <div className="mt-1">
                <Textarea
                  placeholder="Describe your experience details, achievements, or relevant coursework"
                  value={experience.description}
                  onChange={(e) => handleExperienceChange(experience.id, 'description', e.target.value)}
                  rows={4}
                />
                {/* <div className="mt-2 text-xs text-gray-500">
                            Use bullet points (• or -) at the beginning of each line for listing achievements or coursework
                          </div> */}

                {/* Preview of description with formatted bullet points if available */}
                {/* {experience.description && (
                            <div className="mt-3 bg-white p-3 rounded border border-gray-200">
                              <div className="text-xs font-medium text-gray-500 mb-1">Preview:</div>
                              {renderDescription(experience.description)}
                            </div>
                          )} */}
              </div>
            </div>
          </div>
        </div>
      ))}

      <button
        onClick={handleAddExperience}
        type="button"
        className="px-0 py-2 text-sm font-semibold text-color"
      >
        + Add Experience Details
      </button>
      {error && (
        <p className="mt-1 text-sm text-red-500">
          {error}
        </p>
      )}
    </div>
  );
};

export default WorkExperienceForm;